/*
 * The name this browser posts scores under.
 *
 * Kept apart from both of its neighbours on purpose. It is not a *setting* —
 * `settings.mjs` holds display preferences and states as a rule that nothing in
 * it reaches the server, which this plainly does. And it is not part of
 * `playRecord.mjs`, whose whole premise is that it records a fact about the
 * machine rather than about a person; a remembered name is exactly the opposite.
 * So it gets its own key and its own file, and the line stays legible.
 *
 * This is still not an account. Nothing is verified, nothing is reserved, and
 * two people typing the same name are two rows on the board with the same label
 * — which is what the board already was. All it buys is not retyping.
 */

// The backend truncates at the same number; matching here means the name shown
// on the results screen is the name that reached the board, not a longer one
// that was quietly cut on the way.
export const MAX_NAME_LENGTH = 40;

const STORAGE_KEY = 'starguessr:name';

export function cleanName(raw) {
  return typeof raw === 'string' ? raw.trim().slice(0, MAX_NAME_LENGTH) : '';
}

export function getPlayerName() {
  try {
    return cleanName(window.localStorage.getItem(STORAGE_KEY));
  } catch {
    // Private windows, blocked site data, or something else's key in our slot.
    return '';
  }
}

/*
 * Only ever called once a submission has actually succeeded. Remembering a name
 * the server rejected would auto-submit under it forever.
 */
export function rememberPlayerName(name) {
  const clean = cleanName(name);
  if (!clean) return '';
  try {
    window.localStorage.setItem(STORAGE_KEY, clean);
  } catch {
    // Not being able to remember it costs a retype, and nothing else.
  }
  return clean;
}

export function forgetPlayerName() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // As above: forgetting is allowed to fail.
  }
}
